import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import { FilesRoute } from '@/modules/to/creativelibrary/filelibrary.constants';

export const router = PageRouteConfig.factory(
  {
    path: `/${FilesRoute}`,
    name: FilesRoute,
    component: () =>
      import(/* webpackChunkName: "creative-library-page" */ './pages/CreativeLibraryPage.vue'),
  },
  Module.CREATIVE
);
